import React from "react";

export default class TrudatSocial extends React.Component {
  render() {
    if (!this.props.stats) {
      return null;
    }

    return (
      <div className="hp__box__trudat-social">
        <span
          className="hp__box__trudat-trending-group"
          style={{
            color: this.props.reactionsColor === "1" ? "#deff00" : "#fff"
          }}
        >
          <img
            className="hp__box__trudat-trending-icon"
            alt=""
            src={
              this.props.reactionsColor === "1"
                ? window.STATIC_DOMAIN + "/gfx/trudat/trending.png"
                : window.STATIC_DOMAIN + "/gfx/trudat/trending_white.png"
            }
          />
          {this.props.stats.reactions} REAKCJI
        </span>
        <span className="hp__box__trudat-social-group">
          <img
            alt="Udostępnień"
            src={window.STATIC_DOMAIN + "/gfx/trudat/facebook.svg"}
            className="hp__box__trudat-social-icon"
          />
          <span className="hp__box__social__trudat__triangle-wrapper">
            <span className="hp__box__social__trudat__triangle"> </span>
            <span className="hp__box__social__trudat__text">
              {" "}
              {this.props.stats.shares}{" "}
            </span>
          </span>
        </span>
        <span className="hp__box__trudat-social-group">
          <img
            alt="Komentarzy"
            src={window.STATIC_DOMAIN + "/gfx/trudat/dymek.svg"}
            className="hp__box__trudat-social-icon"
          />
          <span className="hp__box__social__trudat__triangle-wrapper">
            <span className="hp__box__social__trudat__triangle"> </span>
            <span className="hp__box__social__trudat__text">
              {" "}
              {this.props.stats.comments}{" "}
            </span>
          </span>
        </span>
      </div>
    );
  }
}
